import { FormGroup } from "@angular/forms";
import { IAddressModel, ICountryDtoModel, IFormMapping, ILookUpType } from "lib-core-shared";
export class AddressFormMapping implements IFormMapping<IAddressModel|undefined> {
    toForm(model: IAddressModel | undefined, group: FormGroup, country?: ILookUpType): void {
        if (model) {
            group.controls.addressLine1.setValue(model.addressLine1);
            group.controls.addressLine2.setValue(model.addressLine2);
            group.controls.countyState.setValue(model.countyState);
            group.controls.townCity.setValue(model.townCity);
            group.controls.postalCode.setValue(model.postalCode);
            if(country){
                group.controls.country.setValue({code: country?.code, name: country?.name});
            }else if(model.countryCode && model.countryName){
                group.controls.country.setValue({code: model.countryCode, name: model.countryName});
            }
            group.controls.isVerified?.setValue(model.isVerified);
        }
    }
    toApplicationModel(group: FormGroup, country?: ILookUpType): IAddressModel | undefined {
        let r = group ? {
            addressLine1: group?.controls?.addressLine1?.value ?  group.controls.addressLine1.value : '',
            addressLine2: group?.controls?.addressLine2?.value ?  group.controls.addressLine2.value : '',
            townCity: group?.controls?.townCity?.value ?  group.controls.townCity.value : '',
            countyState: group?.controls?.countyState?.value ?  group.controls.countyState.value : '',
            postalCode:  group?.controls?.postalCode?.value ?  group.controls.postalCode.value : '',
            isVerified:  group?.controls?.isVerified?.value,
            
        } as IAddressModel : undefined;

        if(country && r){
            r.countryCode = country.code ? country.code : '';
            r.countryName = country.name ? country.name : '';
        }

        return r
    }
}